module.exports = __webpack_public_path__ + "img/yuanfucailiao.7ebddd02.jpg";